module.exports = __webpack_public_path__ + "static/media/HW_mb_icon.e506f2f0.png";